class ProductSaleIcon {
  constructor() {
    this.saleIconWrapper = document.querySelector('[data-product-sale-icon-wrapper]');
    if (!this.saleIconWrapper) return;
    
    this.variantData = this.getVariantData();
    this.checkVariantImmediately();
    this.initEventListeners();
    this.setupMobileContainment();
  }
  
  getVariantData() {
    const variantDataElement = document.querySelector('[data-variant-json]');
    if (variantDataElement) {
      try {
        return JSON.parse(variantDataElement.textContent);
      } catch (e) {
        console.error('Error parsing variant data:', e);
      }
    }
    return [];
  }
  
  checkVariantImmediately() {
    const currentVariantId = this.getCurrentVariantId();
    if (currentVariantId) {
      const variant = this.variantData.find(v => v.id === currentVariantId);
      this.updateSaleIcon(variant);
    }
  }
  
  getCurrentVariantId() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    if (variantParam) return parseInt(variantParam);
    
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) return parseInt(variantSelect.value);
    
    const checkedRadio = document.querySelector('input[type="radio"][name="id"]:checked');
    if (checkedRadio && checkedRadio.value) return parseInt(checkedRadio.value);
    
    if (this.variantData.length > 0) return this.variantData[0].id;
    
    return null;
  }
  
  initEventListeners() {
    document.addEventListener('variantChange', (event) => {
      if (event.detail && event.detail.variant) {
        this.updateSaleIcon(event.detail.variant);
      }
    });
    
    const variantSelects = document.querySelectorAll('select[name="id"]');
    variantSelects.forEach(select => {
      select.addEventListener('change', (event) => {
        const variantId = parseInt(event.target.value);
        const variant = this.variantData.find(v => v.id === variantId);
        this.updateSaleIcon(variant);
      });
    });
    
    const variantRadios = document.querySelectorAll('input[type="radio"][name="id"]');
    variantRadios.forEach(radio => {
      radio.addEventListener('change', (event) => {
        if (event.target.checked) {
          const variantId = parseInt(event.target.value);
          const variant = this.variantData.find(v => v.id === variantId);
          this.updateSaleIcon(variant);
        }
      });
    });
  }
  
  updateSaleIcon(variant) {
    if (!variant) {
      this.hideSaleIcon();
      return;
    }
    
    if (variant.compare_at_price > variant.price) {
      this.showSaleIcon();
    } else {
      this.hideSaleIcon();
    }
  }
  
  showSaleIcon() {
    this.saleIconWrapper.classList.add('sale-icon-visible');
  }
  
  hideSaleIcon() {
    this.saleIconWrapper.classList.remove('sale-icon-visible');
  }
  
  setupMobileContainment() {
    if (window.innerWidth > 749) return;
    
    const saleIcon = this.saleIconWrapper;
    if (!saleIcon) return;
    
    const checkContainment = () => {
      const mainPhotos = document.querySelector('.product__main-photos');
      if (mainPhotos && saleIcon.parentElement !== mainPhotos) {
        mainPhotos.appendChild(saleIcon);
      }
    };
    
    setInterval(checkContainment, 1000);
    window.addEventListener('scroll', checkContainment);
    window.addEventListener('resize', checkContainment);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductSaleIcon();
  });
} else {
  new ProductSaleIcon();
}